// from Shopify's utilities: https://github.com/Shopify/javascript-utilities/blob/master/src/dom.ts

// Polyfill for .matches()
// https://developer.mozilla.org/en/docs/Web/API/Element/matches
export function matches(node, selector) {
  if (node.matches) {
    return node.matches(selector);
  }

  const matchesList = (node.ownerDocument || document).querySelectorAll(
    selector,
  );
  let i = matchesList.length;
  //eslint-disable-next-line
  while (--i >= 0 && matchesList.item(i) !== node) {}
  return i > -1;
}
